/**
 * Implements Mapbox API to add custom controls along Mapbox out of the
 * controls. This control provides checkboxes to show/hide layers. The
 * constructor takes a mapLayers array that contains the layer name
 * used to show/hide the layer.
 */
export default class MapLayerControl {
    constructor(mapLayers) {
        this._onClickMapView = this._onClickMapView.bind(this);
        this._onClickSatelliteView = this._onClickSatelliteView.bind(this);
        this._onClickMapLayer = this._onClickMapLayer.bind(this);
        this._onClickMapLayerItem = this._onClickMapLayerItem.bind(this);
        this._mapLayers = mapLayers;
    }

    onAdd(map) {
        this._map = map;
        this._container = document.createElement('div');

        this._mainContainer = document.createElement('div');
        this._mainContainer.className = 'mapboxgl-ctrl mapboxgl-ctrl-text-group';

        this._mapViewButton = document.createElement('button');
        this._mapViewButton.setAttribute('aria-label', 'Toggle Map View');
        this._mapViewButton.type = 'button';
        this._mapViewButton.innerHTML = 'Map';
        this._mapViewButton.addEventListener('click', this._onClickMapView);
        this._mainContainer.appendChild(this._mapViewButton);

        this._sateliteViewButton = document.createElement('button');
        this._sateliteViewButton.setAttribute('aria-label', 'Toggle Satellite View');
        this._sateliteViewButton.type = 'button';
        this._sateliteViewButton.innerHTML = 'Satellite';
        this._sateliteViewButton.addEventListener('click', this._onClickSatelliteView);
        this._mainContainer.appendChild(this._sateliteViewButton);

        if (this._mapLayers && this._mapLayers.length > 0) {
            this._mapLayerButton = document.createElement('button');
            this._mapLayerButton.setAttribute('aria-label', 'Show Layer View Options');
            this._mapLayerButton.type = 'button';
            this._mapLayerButton.innerHTML = 'Layers';
            this._mapLayerButton.addEventListener('click', this._onClickMapLayer);
            this._mainContainer.appendChild(this._mapLayerButton);
        }

        this._container.appendChild(this._mainContainer);

        // Now add the layer list.
        if (this._mapLayers && this._mapLayers.length > 0) {
            this._supportContainer = document.createElement('div');
            this._supportContainer.className = 'mapboxgl-ctrl mapboxgl-ctrl-text-group mapboxgl-ctrl-sub-group not-shown';

            for (let i = 0; i < this._mapLayers.length; ++i) {
                const layerCheckbox = document.createElement('input');
                layerCheckbox.type = 'checkbox';
                layerCheckbox.id = `layer_checkbox_${i}`;
                layerCheckbox.name = `layer_checkbox_${i}`;
                layerCheckbox.checked = true;
                layerCheckbox.addEventListener('change', () => {
                    this._onClickMapLayerItem(this._mapLayers[i].layers, layerCheckbox.checked);
                });

                const layerLabel = document.createElement('label');
                layerLabel.htmlFor = `layer_checkbox_${i}`;
                layerLabel.innerHTML = this._mapLayers[i].name;

                this._supportContainer.appendChild(layerCheckbox);
                this._supportContainer.appendChild(layerLabel);
            }

            this._container.appendChild(this._supportContainer);
        }

        return this._container;
    }

    _onClickMapView() {
        this._map.setLayoutProperty('fixed-satellite', 'visibility', 'none');
    }

    _onClickSatelliteView() {
        this._map.setLayoutProperty('fixed-satellite', 'visibility', 'visible');
    }

    _onClickMapLayer() {
        this._supportContainer.classList.toggle('not-shown');
    }

    _onClickMapLayerItem(layers, isChecked) {
        let visibilitySetting = 'visible';

        if (isChecked) {
            visibilitySetting = 'visible';
        }
        else {
            visibilitySetting = 'none';
        }

        layers.forEach((layer) => {
            this._map.setLayoutProperty(layer, 'visibility', visibilitySetting);
        });
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }
}
